import IconsComponent from './icon.vue'
const Icon = {
    install: function(Vue) {
            Vue.component('Icon', IconsComponent)
        } //'Loading'这就是后面可以使用的组件的名字，install是默认的一个方法
};
export default Icon